import { createContext } from "react";

interface ILayoutContext {
  appBarHeight: number;
}

interface ILayoutContextWithDispatch extends ILayoutContext {
  dispatch?: React.Dispatch<AppBarHeightChangedAction>;
}

export const LayoutContext = createContext<ILayoutContextWithDispatch>({
  appBarHeight: 0,
});

const APPBAR_HEIGHT_CHANGED = "APPBAR_HEIGHT_CHANGED";
interface AppBarHeightChangedAction {
  type: string;
  height: number;
}

export const setAppBarHeightChanged = (
  height: number
): AppBarHeightChangedAction => {
  return { type: APPBAR_HEIGHT_CHANGED, height };
};

export const layoutContextReducer = (
  previousValue: ILayoutContext = { appBarHeight: 0 },
  action: AppBarHeightChangedAction
): ILayoutContext => {
  switch (action.type) {
    case APPBAR_HEIGHT_CHANGED:
      if (previousValue.appBarHeight === action.height) {
        return previousValue;
      }

      return { ...previousValue, appBarHeight: action.height };
    default:
      return previousValue;
  }
};
